import * as React from "react";
import PropTypes from 'prop-types';

const SvgCheckboxRounded = props => {
  if (props.id !== "_svgcheckboxrounded") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M3.2 16C3.2 8.935 8.934 3.2 16 3.2c7.066 0 12.8 5.735 12.8 12.8 0 7.066-5.735 12.8-12.8 12.8-7.066 0-12.8-5.734-12.8-12.8zm1.28 0c0 6.351 5.17 11.521 11.52 11.521s11.52-5.17 11.52-11.52S22.35 4.48 16 4.48 4.48 9.65 4.48 16zm16.943-6.4l-7.758 7.758-3.88-3.878L7.2 16.065l6.465 6.465 10.344-10.344L21.423 9.6z" fill="#202020" /></svg>;
};

SvgCheckboxRounded.displayName = "_svgcheckboxrounded";
SvgCheckboxRounded.propTypes = {
  id: PropTypes.string
};
SvgCheckboxRounded.defaultProps = {
  id: ''
};
export default SvgCheckboxRounded;